import React, { useState } from "react";
import axios from "axios";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { __API_URL__ } from "../../SERVER_URL";
import { toast } from "react-toastify";

const PasswordConfirmation = ({
  show,
  onHide,
  setIsCorrectPass,
  handleCancelClick,
  setCertificationStatus,
  onHideonSuccess,
}) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${__API_URL__}/api/auth/staff/verify-password/`,
        { password },
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );
      toast.success(response.data.message);
      setIsCorrectPass(true);
      onHideonSuccess();
    } catch (error) {
      toast.error(error.response?.data?.error);
      setIsCorrectPass(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setCertificationStatus("");
    handleCancelClick();
    onHide();
  };

  return (
    <Modal
      open={show}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onHide();
        }
      }}
      disableAutoFocus
      disableEnforceFocus
      disablePortal
      aria-labelledby="password-account-title"
      aria-describedby="password-account-description"
      sx={{
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      }}
    >
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Please Enter Your Password
        </Typography>
        <TextField
          label="Enter password"
          type={showPassword ? "text" : "password"}
          variant="outlined"
          fullWidth
          value={password}
          autoComplete="new-password"
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          sx={{ mb: 3 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Button
            sx={{ px: 3, py: 1 }}
            variant="contained"
            color="error"
            onClick={handleCancel}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            sx={{ px: 3, py: 1 }}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Submit"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PasswordConfirmation;
